export const PREVIEW_WIDGET_VERTICAL_PADDING = 50;
export const PREVIEW_WIDGET_VERTICAL_PADDING_MOBILE = 30;
